import { CardProps } from '@/ui';
import { prependToNonHttpsHrefs } from '@lib/server';

import { CardBlockProps } from '.';

export const transformCardData = ({
  params,
  href,
  actions,
  rte_description,

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transition,
  ...data
}: CardBlockProps): CardProps => {
  const prefix = params?.venue ? `/${params.venuesPage}/${params.venue}` : '';

  return {
    ...data,
    href: href && !href?.includes('https://') ? `${prefix}${href}` : href,
    actions: {
      primary: {
        ...actions?.primary,
        href:
          !actions?.primary?.href?.includes('https://') && params?.venue
            ? `${prefix}${actions?.primary?.href}`
            : actions?.primary?.href,
      },
      secondary: {
        ...actions?.secondary,
        href:
          !actions?.secondary?.href?.includes('https://') && params?.venue
            ? `${prefix}${actions?.secondary?.href}`
            : actions?.secondary?.href,
      },
    },
    description: params?.venue
      ? prependToNonHttpsHrefs(rte_description?.content || '', `/${params.venuesPage}/${params.venue}`)
      : rte_description?.content,
  };
};
